import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

type ImageViewerProps = {
  src: string;
  alt?: string;
  thumbnailHeight?: number | string;
  thumbnailWidth?: number | string;
  style?: React.CSSProperties;
};

const ImageViewer: React.FC<ImageViewerProps> = ({
  src,
  alt = '',
  thumbnailHeight = 100,
  thumbnailWidth = 100,
  style,
}) => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <img
        src={src}
        alt={alt}
        onClick={handleClickOpen}
        style={{
          cursor: 'pointer',
          height: thumbnailHeight,
          width: thumbnailWidth,
          borderRadius: 8,
          objectFit: 'cover',
          ...style,
        }}
      />

      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <IconButton
          onClick={handleClose}
          style={{
            position: 'absolute',
            right: 8,
            top: 8,
            zIndex: 10,
            background: 'white',
          }}
        >
          <CloseIcon />
        </IconButton>
        <DialogContent>
          <img
            src={src}
            alt={alt}
            style={{
              width: '100%',
              height: 'auto',
              borderRadius: 8,
              maxHeight: '80vh',
              objectFit: 'contain',
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ImageViewer;
